import React from "react";
import "./Hero.css";
import {
  heroBg,
  beefLogo,
  emmyBanner,
  emmyBannerMobile,
} from "../data/assets";

export default function Hero() {
  return (
    <section className="beef-hero">
      <img
        className="beef-hero__bg"
        src={heroBg}
        alt=""
        aria-hidden="true"
        decoding="async"
        fetchPriority="high"
      />
      <div className="beef-hero__overlay" aria-hidden="true" />

      <div className="beef-hero__content beef-container">
        <div className="beef-hero__masthead">
          <img
            className="beef-hero__logo"
            src={beefLogo}
            alt="BEEF"
            decoding="async"
          />
          <picture className="beef-hero__banner-pic">
            <source media="(max-width: 768px)" srcSet={emmyBannerMobile} />
            <img
              className="beef-hero__banner"
              src={emmyBanner}
              alt="Including 16 Emmy Award Nominations — Outstanding Limited Series"
              decoding="async"
            />
          </picture>
        </div>

        <div className="beef-hero__copy">
          <h1 className="beef-hero__headline">
            <span className="beef-hero__headline-line beef-hero__headline-line--blue">
              Release Your Rage.
            </span>
            <span className="beef-hero__headline-line">
              <span className="beef-hero__hl-accent">F</span>eel{" "}
              <span className="beef-hero__hl-accent">Y</span>our{" "}
              <span className="beef-hero__hl-accent">C</span>alm.
            </span>
          </h1>
          <p className="beef-hero__intro">
            Experience a week of wellness brought to you by BEEF, the most{" "}
            <span className="beef-nowrap">Emmy&reg;-nominated</span> Limited
            Series of the year.
            <br />
            <br />
            Join us August 10 &ndash; 14 for five days of complimentary wellness
            experiences and exclusive giveaways at partner locations across Los
            Angeles.
          </p>
        </div>
      </div>
    </section>
  );
}
